import { UserSelectLocale } from "../index";

const locale: UserSelectLocale = {
  placeholder: 'click to search',
  title: "user search",
};

export default locale
